import { NUMBER_MINUS_ONE } from '../../../../constants/constant.numbers'
import { FundCategoryCode } from './fund-category-code.enum'
import { FundCategoryModel } from './fund-category-model'

export class FundCategoryOrderDefinition {
  private fundCategoryCodeOrderMap: Map<string, number> = new Map<
    string,
    number
  >()
  private delimiter = ''
  constructor() {
    // Equity
    this.orderDefinitionForEquity()
    // Fixed Income
    this.orderDefinitionForFixedIncome()
    // Multi Asset
    this.orderDefinitionForMultiAsset()
    // Cash Equivalent
    this.orderDefinitionForCashEquivalent()
  }

  private orderDefinitionForEquity() {
    this.pushFundCategoryOrderDef(FundCategoryCode.Equity, FundCategoryCode.Us)
    this.pushFundCategoryOrderDef(
      FundCategoryCode.Equity,
      FundCategoryCode.Large,
    )
    this.pushFundCategoryOrderDef(FundCategoryCode.Equity, FundCategoryCode.Mid)
    this.pushFundCategoryOrderDef(
      FundCategoryCode.Equity,
      FundCategoryCode.Small,
    )
    this.pushFundCategoryOrderDef(
      FundCategoryCode.Equity,
      FundCategoryCode.InternationalGlobal,
    )
    this.pushFundCategoryOrderDef(
      FundCategoryCode.Equity,
      FundCategoryCode.Global,
    )
    this.pushFundCategoryOrderDef(
      FundCategoryCode.Equity,
      FundCategoryCode.NonUS,
    )
    this.pushFundCategoryOrderDef(
      FundCategoryCode.Equity,
      FundCategoryCode.Developed,
    )
    this.pushFundCategoryOrderDef(
      FundCategoryCode.Equity,
      FundCategoryCode.Emerging,
    )
    this.pushFundCategoryOrderDef(
      FundCategoryCode.Equity,
      FundCategoryCode.Blend,
    )
    this.pushFundCategoryOrderDef(
      FundCategoryCode.Equity,
      FundCategoryCode.Growth,
    )
    this.pushFundCategoryOrderDef(
      FundCategoryCode.Equity,
      FundCategoryCode.Value,
    )
    this.pushFundCategoryOrderDef(
      FundCategoryCode.Equity,
      FundCategoryCode.Active,
    )
    this.pushFundCategoryOrderDef(
      FundCategoryCode.Equity,
      FundCategoryCode.Index,
    )
  }

  // eslint-disable-next-line max-statements
  private orderDefinitionForFixedIncome() {
    this.pushFundCategoryOrderDef(
      FundCategoryCode.FixedIncome,
      FundCategoryCode.Us,
    )
    this.pushFundCategoryOrderDef(
      FundCategoryCode.FixedIncome,
      FundCategoryCode.TreasuryAgency,
    )
    this.pushFundCategoryOrderDef(
      FundCategoryCode.FixedIncome,
      FundCategoryCode.InvGradeCorp,
    )
    this.pushFundCategoryOrderDef(
      FundCategoryCode.FixedIncome,
      FundCategoryCode.BelowInvGrade,
    )
    this.pushFundCategoryOrderDef(
      FundCategoryCode.FixedIncome,
      FundCategoryCode.Muni,
    )
    this.pushFundCategoryOrderDef(
      FundCategoryCode.FixedIncome,
      FundCategoryCode.MultiSector,
    )
    this.pushFundCategoryOrderDef(
      FundCategoryCode.FixedIncome,
      FundCategoryCode.InternationalGlobal,
    )
    this.pushFundCategoryOrderDef(
      FundCategoryCode.FixedIncome,
      FundCategoryCode.Global,
    )
    this.pushFundCategoryOrderDef(
      FundCategoryCode.FixedIncome,
      FundCategoryCode.NonUS,
    )
    this.pushFundCategoryOrderDef(
      FundCategoryCode.FixedIncome,
      FundCategoryCode.Emerging,
    )
    this.pushFundCategoryOrderDef(
      FundCategoryCode.FixedIncome,
      FundCategoryCode.Developed,
    )
    this.pushFundCategoryOrderDef(
      FundCategoryCode.FixedIncome,
      FundCategoryCode.Long,
    )
    this.pushFundCategoryOrderDef(
      FundCategoryCode.FixedIncome,
      FundCategoryCode.Intermediate,
    )
    this.pushFundCategoryOrderDef(
      FundCategoryCode.FixedIncome,
      FundCategoryCode.Short,
    )
    this.pushFundCategoryOrderDef(
      FundCategoryCode.FixedIncome,
      FundCategoryCode.Active,
    )
    this.pushFundCategoryOrderDef(
      FundCategoryCode.FixedIncome,
      FundCategoryCode.Index,
    )
  }

  private orderDefinitionForMultiAsset() {
    this.pushFundCategoryOrderDef(
      FundCategoryCode.MultiAsset,
      FundCategoryCode.Us,
    )
    this.pushFundCategoryOrderDef(
      FundCategoryCode.MultiAsset,
      FundCategoryCode.InternationalGlobal,
    )
    this.pushFundCategoryOrderDef(
      FundCategoryCode.MultiAsset,
      FundCategoryCode.TargetDate,
    )
    this.pushFundCategoryOrderDef(
      FundCategoryCode.MultiAsset,
      FundCategoryCode.USBalanced,
    )
    this.pushFundCategoryOrderDef(
      FundCategoryCode.MultiAsset,
      FundCategoryCode.Balanced,
    )
    this.pushFundCategoryOrderDef(
      FundCategoryCode.MultiAsset,
      FundCategoryCode.TargetAllocation,
    )
  }

  private orderDefinitionForCashEquivalent() {
    this.pushFundCategoryOrderDef(
      FundCategoryCode.CashEquivalent,
      FundCategoryCode.Taxable,
    )
    this.pushFundCategoryOrderDef(
      FundCategoryCode.CashEquivalent,
      FundCategoryCode.Muni,
    )
    this.pushFundCategoryOrderDef(
      FundCategoryCode.CashEquivalent,
      FundCategoryCode.StableValue,
    )
  }

  private pushFundCategoryOrderDef(
    mainHeader: FundCategoryCode,
    header?: FundCategoryCode,
    subHeader?: FundCategoryCode,
  ) {
    const key =
      mainHeader +
      this.delimiter +
      (header || '') +
      this.delimiter +
      (subHeader || '')
    this.fundCategoryCodeOrderMap.set(
      key,
      this.fundCategoryCodeOrderMap.size + 1,
    )
  }

  getFundCategoryOrder(fundCategoryModel: FundCategoryModel): number {
    const key =
      fundCategoryModel.categoryLvl1Name +
      this.delimiter +
      (fundCategoryModel.categoryLvl2Name || '')
    return this.fundCategoryCodeOrderMap.get(key) || NUMBER_MINUS_ONE
  }
}
